export default __webpack_public_path__ + "static/ecom_6-27bcc4c7cac2122d747160a523e4a9bf.jpeg";